import { pushToDataLayer } from "@/utils/pushToDataLayer";
import Image from "next/image";
import React, { useState } from "react";
import PostPaywallUnlockAttemptModal from "@/components/modules/Post/Paywall/PostPaywallUnlockAttemptModal";

export const PostNavigationUnlockButton: React.FC<{ title?: string }> = ({ title }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  const handleUnlockButton = () => {
    // article_interaction (unlock)
    pushToDataLayer({
      event: "article_interaction",
      interaction_type: "unlock",
      interaction_option: title,
    });
    setIsDialogVisible(!isDialogVisible);
  };

  return (
    <>
      <li className="mx-3 flex w-full items-center justify-center lg:w-auto">
        <button
          className="flex items-center rounded-full p-2 transition-colors ease-in-out hover:bg-gray-100 dark:hover:bg-white-25"
          onClick={() => handleUnlockButton()}
        >
          <Image
            src="/assets/images/icons/unlock-new.svg"
            alt="Unlock Button"
            width={20}
            height={20}
            className="mr-[10px] dark:invert"
          />
          <span className="hidden dark:text-white lg:block">Odemknout</span>
        </button>
      </li>
      <PostPaywallUnlockAttemptModal isDialogVisible={isDialogVisible} setIsDialogVisible={setIsDialogVisible} />
    </>
  );
};
